/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfNavigationItemDto } from '../../models/platform-api-result-of-navigation-item-dto';

export interface DeleteNavigationitemsId$Params {
  id: string;
}

export function deleteNavigationitemsId(http: HttpClient, rootUrl: string, params: DeleteNavigationitemsId$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfNavigationItemDto>> {
  const rb = new RequestBuilder(rootUrl, deleteNavigationitemsId.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfNavigationItemDto>;
    })
  );
}

deleteNavigationitemsId.PATH = '/api/navigationitems/{id}';
